export default __webpack_public_path__ + "static/media/15.912e6e8e.jpg";